"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.createIsProcessingReducer = exports.createErrorMessageReducer = exports.createReducer = void 0;
const lodash_1 = require("lodash");
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createReducer = (initialState) => (reducerMap) => (state = initialState, action) => {
    const type = lodash_1.get(action, 'type', '');
    const reducer = reducerMap[type];
    return reducer ? reducer(state, action) : state;
};
exports.createReducer = createReducer;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createErrorMessageReducer = (prefix) => {
    return (state = null, action) => {
        const type = lodash_1.get(action, 'type', '').toLowerCase();
        if (!type.startsWith(`${prefix.toLowerCase()}/`)) {
            return state;
        }
        if (type.endsWith('/failure')) {
            return lodash_1.get(action, 'errorMessage', null);
        }
        if (type.endsWith('/request')) {
            return null;
        }
        return state;
    };
};
exports.createErrorMessageReducer = createErrorMessageReducer;
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const createIsProcessingReducer = (prefix) => {
    return (state = false, action) => {
        const type = lodash_1.get(action, 'type', '').toLowerCase();
        if (!type.startsWith(`${prefix.toLowerCase()}/`)) {
            return state;
        }
        if (type.endsWith('/request')) {
            return true;
        }
        if (type.endsWith('/success')) {
            return false;
        }
        if (type.endsWith('/failure')) {
            return false;
        }
        return state;
    };
};
exports.createIsProcessingReducer = createIsProcessingReducer;
//# sourceMappingURL=utils.js.map